//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      default: 'прикрепить файл'
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event)
        }
      }
    },
    hasValue () {
      return !!this.value
    }
  }
}
